export default "__VITE_ASSET__CqSu7ALb__"